<div id="hotelbooking" class="registration container">
  <form #hotelbookingForm="ngForm" [ngClass]="{'form-complete': hotelbookingForm.valid}" name="hotelbookingForm"
    (ngSubmit)="forward(hotelbookingForm)" novalidate autocomplete="off" appScrollToInvalid
    [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.HOTEL.heading' | copy | async }}</h1>

    <section class="card">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.label' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>

      <article>
        <mat-radio-group [(ngModel)]="roommate" name="hotelNeeded" #hotelNeeded="ngModel" required
          (ngModelChange)="clearRequests()">
          <mat-radio-button [value]="'yes'"  [checked]="roommate === 'yes'">Yes</mat-radio-button>
          <mat-radio-button [value]="'no'" [checked]="roommate === 'no'">No</mat-radio-button>
          <mat-radio-button *ngIf="attendee.PAXTypeNo !== 8" [value]="true" [checked]="roommate === true">My roommate has already
            requested our hotel accommodations.</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation [object]="hotelNeeded" isRequired=true></app-validation></mat-error>
          </div>
        </mat-radio-group>
        <div class="w-100 standout-box" [innerHTML]='"copy.html.hotelmapinfo" | copy | async'></div>
      </article>
    </section>
    <section class="card" *ngIf="roommate === 'yes'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.hotels' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div class="error ng-invalid" *ngFor="let error of getNonContiguousHotels()">
          <strong *ngIf="attendee.PAXTypeNo != 10" ><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i
                class="fas fa-circle-thin fa-stack-2x"></i></span> Rooms selected not contiguous for {{error}}.
          </strong>
          <strong *ngIf="attendee.PAXTypeNo == 10" ><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i
            class="fas fa-circle-thin fa-stack-2x"></i></span> Rooms selected not contiguous for the hotel.
      </strong>
        </div>
        <div class="bacon" [hidden]="!noHotel">
          <strong><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i
                class="fas fa-circle-thin fa-stack-2x"></i></span>Please select at least one hotel room.</strong>
        </div>
        <div class="w-100 pt-3 font-weight-bold" [innerHTML]='"copy.html.hoteltext" | copy | async '></div>
        <div class="table-responsive">
          <table class="table hotelTable" *ngIf="hotelList != undefined">
            <thead>
              <tr>
                <th></th>
                <th *ngIf="this.preextend > 0" class="preextension-b extension-header" [attr.colspan]="preextend">Pre
                  Extension</th>
                <th *ngIf="this.groupDays > 0" class="eventDates-b" [attr.colspan]="groupDays + 1">Event Dates</th>
                <th *ngIf="this.postextend > 0" class="postextension-b extension-header" [attr.colspan]="postextend">Post
                  Extension</th>
              </tr>
            </thead>

            <tbody *ngFor="let hotelobj of hotelList.roomTypeList">
              <tr>
                <th rowspan="2" class="hotelDetails" *ngIf="attendee.PAXTypeNo != 10">
                  <h2>{{hotelobj.supplierName}}</h2>
                  <!-- <a class="desktopDetails" ng-if="!hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.showdetails"|copy|async}}</a>
                  <a class="desktopDetails" ng-if="hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.hidedetails"|copy|async}}</a> -->
                  <p class="m-0"><a class="mobileDetails"
                      (click)="showModal(hotelobj)">{{"copy.label.HOTEL.BOOKING.mobiledetails"|copy|async}}</a></p>
                </th>
                <th rowspan="2" class="hotelDetails" *ngIf="attendee.PAXTypeNo == 10">
                  <h2>Hotel To Be Assigned</h2>
                  <!-- <a class="desktopDetails" ng-if="!hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.showdetails"|copy|async}}</a>
                  <a class="desktopDetails" ng-if="hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.hidedetails"|copy|async}}</a> -->
                </th>
                <!-- CUSTOM LINE -->
                <th [ngClass]="{'custom-cell-date-b': attendee.PAXTypeNo != 10, 'custom-cell-date-c': attendee.PAXTypeNo == 10}" *ngFor="let n of dateRange"><span class="day">{{n|date:"EEE": "-0500"}}</span><span
                    class="date">{{n| date:"MMM d": "-0500"}}</span></th>
                <!-- ORIGINAL LINE -->
                    <!-- <th *ngFor="let n of dateRange"><span class="day">{{n|date:"EEE": "-0500"}}</span><span
                    class="date">{{n| date:"MMM d": "-0500"}}</span></th> -->
              </tr>
              <tr>
                <!-- <td></td> -->
                <td *ngFor="let n of hotelobj.roomNightsListWithRate" [ngClass]="{'prepost-c': n.groupDateFlag!=='GRP'}">
                  <div class="d-flex justify-content-center flex-column align-items-center"
                    *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && !n.isBookedAsPending ">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;"
                      [disabled] = "pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID "
                      [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)"
                      [unchecked] = "unchecked()"
                      (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">

                    </mat-checkbox>
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <div class="d-flex justify-content-center flex-column align-items-center"
                    *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && n.isBookedAsPending">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;"
                      [disabled] = "(pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID)"
                      [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)"
                      (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">

                    </mat-checkbox>
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <!-- ADDED: [ngClass]="{'not-available': !isHotelAvailableOnDate(hotelobj, n.blockDate)}" -->
                  <div class="d-flex justify-content-center flex-column align-items-center"
                    *ngIf="!isHotelAvailableOnDate(hotelobj, n.blockDate)" [ngClass]="{'not-available': !isHotelAvailableOnDate(hotelobj, n.blockDate)}">
                    <span class="material-icons">
                      clear
                    </span>
                    <div class="hotel_desc">{{"copy.label.HOTEL.BOOKING.notavail"|copy|async}} </div>
                  </div>
                </td>
              </tr>
              <!-- <tr>&nbsp;&nbsp;</tr> -->
            </tbody>
          </table>
        </div>
      </article>
    </section>
    <section class="card" *ngIf="roommate === 'yes'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.roominfo' | copy | async }}
        </div>
      </div>
      <article>
        <!-- {{ 'copy.label.HOTEL.roompref' |copy |async}}
        <div class="radio-group">
          <mat-radio-group [(ngModel)]="attendee.HotelSmoking" name="smoking" >
            <mat-radio-button [value]="true" [checked]="attendee.HotelSmoking === true">Smoking</mat-radio-button>
            <mat-radio-button [value]="false" [checked]="attendee.HotelSmoking === false">Nerron-Smoking</mat-radio-button>
          </mat-radio-group>
        </div> -->
        <!-- <div>
          {{ 'copy.label.HOTEL.special' |copy |async}}
          <textarea name="hotelSpecialRequests" [(ngModel)]="enrollment.HotelSpecialRequests" maxlength="225"></textarea>
        </div> -->
        <div class="card-body w-100">
          <div class="d-flex justify-content-start w-100" [innerHTML]='"copy.html.hotelPrefText" | copy | async'></div>
          <mat-form-field class="prefixInput">
            <mat-label for="beddingPref">{{ 'copy.label.HOTEL.roompref' | copy | async }}</mat-label>
            <mat-select name="beddingPref" id="beddingPref" aria-label="beddingPref" [(ngModel)]="beddingPreference.Value"
              #beddingPref="ngModel" matNativeControl>
              <mat-option *ngFor="let obj of bedTypes" [value]="obj.value">{{ obj.display }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="beddingPref"></app-validation></mat-error>
          </mat-form-field>
          <div class="d-flex justify-content-start w-100">
            <mat-form-field class="w-100">
              <mat-label class="w-100" for="DietaryNeedOther" aria-labelledby="DietaryNeedOther">{{
                'copy.label.HOTEL.special' |copy |async}}</mat-label>
              <textarea matInput class="w-100" name="hotelSpecialRequests" [(ngModel)]="enrollment.HotelSpecialRequests"
                maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*"></textarea>
            </mat-form-field>
          </div>
        </div>
      </article>
      <article *ngIf="attendee.PAXTypeNo !== 8">
     
        <div>{{'copy.HTML.roomsharetext' |copy |async}}<i class="fas fa-asterisk required" style="font-size: .4rem; vertical-align: super"></i></div>
          
        <div class="d-flex justify-content-start w-100">
          <!-- <mat-label for="bookingRoommate">{{ 'copy.label.ROOMMATE.bookingRoommate' | copy | async }}</mat-label>  -->
          <mat-radio-group [(ngModel)]="attendee.$mtcbookingRoommate" name="bookingRoommate" #bookingRoomate="ngModel" required>
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="d-flex justify-content-start w-100" *ngIf="attendee.$mtcbookingRoommate===true">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommateName" aria-labelledby="roommateName" required>{{
              'copy.label.ROOMMATE.roommateName' |copy |async}}</mat-label>
            <textarea matInput class="w-100" #roommatesName="ngModel" name="roommatesName"
              [(ngModel)]="roommateName.Value" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required></textarea>
            <mat-error><app-validation [object]="roommatesName" isRequired=true></app-validation></mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100" *ngIf="attendee.$mtcbookingRoommate===true">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommateEmail" aria-labelledby="roommateEmail">{{ 'copy.label.ROOMMATE.email'
              |copy |async}}</mat-label>
            <textarea matInput class="w-100" #roommatesEmail="ngModel" name="roommatesEmail"
              [(ngModel)]="roommateEmail.Value" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*"></textarea>
            <mat-error><app-validation [object]="roommatesEmail"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </article>
    </section>

    <section class="card" *ngIf="roommate === 'no'">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.nohotellabel' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="enrollment.HotelSpecialRequests" name="noHotelReason" #noHotelReason="ngModel"
          required>
          <mat-radio-button *ngFor="let op of noHotelRadios" [value]="op.value">{{op.display}}</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation [object]="noHotelReason" isRequired=true></app-validation></mat-error>
          </div>
        </mat-radio-group>
        <div class="d-flex justify-content-start w-100" *ngIf="enrollment.HotelSpecialRequests === 'Other' ">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="otherInfo" aria-labelledby="otherInfo">Please provide reason: </mat-label>
            <textarea matInput class="w-100" #otherInfo="ngModel" name="otherInfo" [(ngModel)]="otherRequest"
              maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required></textarea>
            <mat-error><app-validation [object]="otherInfo" isRequired=true></app-validation></mat-error>
          </mat-form-field>
        </div>

      </article>
    </section>
    <section class="card" *ngIf="roommate === true">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.ROOMMATE.header' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="roommatesName" aria-labelledby="roommatesName">{{
              'copy.label.ROOMMATE.roommateNameRequested' |copy |async}}</mat-label>
            <textarea matInput class="w-100" #roommatesName="ngModel" name="roommatesName"
              [(ngModel)]="roommateName.Value" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*" required></textarea>
            <mat-error><app-validation [object]="roommatesName" isRequired="true"></app-validation></mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label for="roommateArrivals">{{ 'copy.label.ROOMMATE.roommateArrival' | copy | async }}</mat-label>
            <mat-select (selectionChange)="updateDate()" #roomateArrivals="ngModel" name="roommateArrivals"
              id="roommateArrivals" aria-label="roommateArrivals" [(ngModel)]="roommateArrival.Value"
              #roommateArrivals="ngModel" matNativeControl required>
              <mat-option *ngFor="let obj of arrivalDates" [value]="obj.value">{{ obj.display }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="roommateArrivals" isRequired="true"></app-validation></mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label for="roommateDepartures">{{ 'copy.label.ROOMMATE.roommateDeparture' | copy | async }}</mat-label>
            <mat-select (selectionChange)="updateArrDate()" name="roommateDepartures" id="roommateDepartures"
              aria-label="roommateDepartures" [(ngModel)]="roommateDeparture.Value" #roommateDepartures="ngModel"
              matNativeControl required>
              <mat-option *ngFor="let obj of departureDates" [value]="obj.value">{{ obj.display }}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="roommateDepartures"></app-validation></mat-error>
          </mat-form-field>
        </div>
      </article>
    </section>

    
    <form #paymentForm="ngForm" name="paymentForm" (ngSubmit)="forward(paymentForm)" *ngIf="roommate === true || roommate === 'yes'"
        novalidate autocomplete="off" appScrollToInvalid
        [ngClass]="{'form-complete': isFormCompleted}">
        <div class="required">
          <label class="required-color" *ngFor="let ccerror of CCerrors">{{ccerror}}</label>
        </div>
        <!-- <div class="required" *ngFor="let ccerror of CCerrors">{{ccerror}}</div> -->

        <section class="card" name="hotelFee" *ngIf="charges.Hotel > 0">
            <div class="card-header">
                <div class="card-title">
                    {{ 'copy.label.PAYMENT.FEESRT10.hotel' | copy | async }} {{charges.Hotel | currency}}
                </div>
            </div>
            <article>
                <div class="card-body w-100">
                    <div [innerHTML]='"copy.html.OtherPayment" | copy | async'></div>
                    <app-collect-payment cardType="Hotel" [ccOnly]="true"></app-collect-payment>
                </div>
            </article>
        </section>

        <section class="card" name="hotelFee">
            <div class="card-header">
                <div class="card-title">
                    {{ 'copy.label.PAYMENT.FEESRT10.hotelguarantee' | copy | async }}
                </div>
            </div>
            <article>
                <div class="card-body w-100">
                    <div [innerHTML]='"copy.html.HotelGuaranteeText"|copy|async'></div>
                    <app-collect-payment cardType="Hotel" [ccOnly]="true"></app-collect-payment>
                </div>
            </article>
        </section>



    </form>
  
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()"
        *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>